<template>
  <div class="purchase-callback">
    <!-- Brand logo: the real DİKO lockup, not the stock Vuexy template mark
         this page used to render. The asset already contains the wordmark, so
         there is no separate "Diko" heading beside it any more. -->
    <b-link
      class="brand-logo"
      :to="{ name: 'home' }"
    >
      <b-img
        :src="appLogoImage"
        alt="DİKO"
        class="brand-logo__image"
      />
    </b-link>
    <!-- /Brand logo-->
    <!-- `processing` shares this card with `success`: in both cases the payment
         itself went through, and the only difference is whether the server has
         finished publishing the subscription yet. The headline is driven by the
         server-confirmed standing rather than by ?status, so a query parameter
         can never on its own congratulate someone on a subscription they do not
         have. -->
    <div
      v-if="isPaid"
      class="success d-flex flex-column justify-content-center"
    >
      <b-card
        text-variant="center"
        class="card"
      >
        <b-avatar
          variant="primary"
          size="70"
          class="shadow mb-2"
        >
          <feather-icon
            size="28"
            :icon="celebrate ? 'CheckIcon' : 'ClockIcon'"
          />
        </b-avatar>
        <h1 class="mb-1 mt-50">
          <span v-if="celebrate">&#127881; Satın Alımınız Gerçekleşti &#127881;</span>
          <span v-else>Ödemeniz alındı</span>
        </h1>
        <b-card-text class="m-auto w-75">
          <p v-if="celebrate">
            Aboneliğiniz başarıyla başlatıldı.
          </p>
          <p v-else>
            Aboneliğinizi tamamlıyoruz. Bu işlem birkaç dakika sürebilir.
          </p>
          <p v-if="refreshState === 'loading'">
            Abonelik ve inceleme bilgileriniz güncelleniyor...
          </p>
          <template v-else-if="refreshState === 'loaded'">
            <!-- <p v-if="reviewDeadlineAt">
              Mesleki bilgileriniz en geç {{ formatDate(reviewDeadlineAt) }} tarihine kadar değerlendirilecektir.
            </p> -->
            <!-- <p v-if="standing.canUseGatedFeatures">
              Abonelik kapsamındaki işlemleri kullanabilirsiniz.
            </p> -->
            <!-- <p v-else>
              Güncel başvuru durumunuzu hesabınızdan inceleyebilirsiniz.
            </p> -->
          </template>
          <p v-else-if="refreshState === 'error'">
            Güncel abonelik ve inceleme bilgilerinizi hesap ayarlarınızdan görüntüleyebilirsiniz.
          </p>
          <!-- With the optional Guide shortcut off, the sentence loses one
               of its two links. Two variants rather than a
               v-if on the link alone, because dropping it inline would leave a
               dangling "veya". Flipping GUIDE_ENABLED restores the original. -->
          <p v-if="guideEnabled">
            DİKO'yu tercih ettiğiniz için teşekkür ederiz. Destek için
            <b-link :to="{ name: 'diko-faq' }">
              Bilgi Bankasını
            </b-link> veya
            <b-link :to="{ name: 'guide' }">
              Kullanım Kılavuzunu
            </b-link> ziyaret edebilirsiniz.
          </p>
          <p v-else>
            DİKO'yu tercih ettiğiniz için teşekkür ederiz. Destek için
            <b-link :to="{ name: 'diko-faq' }">
              Bilgi Bankasını
            </b-link> ziyaret edebilirsiniz.
          </p>
        </b-card-text>
        <div class="mt-2 d-flex flex-wrap justify-content-center">
          <b-button
            variant="primary"
            class="btn-sm-block mb-1 mb-md-0 mr-md-1"
            :to="{ name: 'home' }"
          >
            Uygulamaya Başla
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-sm-block"
            :to="{ name: 'financial-settings' }"
          >
            Aboneliğimi Görüntüle
          </b-button>
        </div>
      </b-card>
    </div>
    <div
      v-else-if="isReviewCompleted"
      class="review-completed d-flex flex-column justify-content-center"
    >
      <b-card
        text-variant="center"
        class="card"
      >
        <b-avatar
          variant="primary"
          size="70"
          class="shadow mb-2"
        >
          <feather-icon
            size="28"
            icon="InfoIcon"
          />
        </b-avatar>
        <h1 class="mb-1 mt-50">
          İnceleme Süresi Tamamlandı
        </h1>
        <b-card-text class="m-auto w-75">
          <p>15 günlük değerlendirme süreniz tamamlandı.</p>
          <p>Güncel başvuru ve abonelik durumunuzu hesabınızdan görüntüleyebilirsiniz.</p>
          <p v-if="refreshState === 'loading'">
            Abonelik ve inceleme bilgileriniz güncelleniyor...
          </p>
          <p v-else-if="refreshState === 'error'">
            Güncel durum bilgilerinizi hesap ayarlarınızdan görüntüleyebilirsiniz.
          </p>
        </b-card-text>
        <div class="mt-2 d-flex flex-wrap justify-content-center">
          <b-button
            variant="primary"
            class="btn-sm-block mb-1 mb-md-0 mr-md-1"
            :to="{ name: 'account-settings' }"
          >
            Başvuru Durumumu Gör
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-sm-block"
            :to="{ name: 'financial-settings' }"
          >
            Aboneliğimi Görüntüle
          </b-button>
        </div>
      </b-card>
    </div>
    <div
      v-else
      class="deny d-flex flex-column justify-content-center"
    >
      <b-card
        text-variant="center"
        class="card bg-dark"
      >
        <b-avatar
          variant="danger"
          size="70"
          class="shadow mb-2"
        >
          <feather-icon
            size="28"
            icon="XIcon"
          />
        </b-avatar>
        <h1 class="mb-1 mt-50 text-white">
          Ödeme tamamlanamadı
        </h1>
        <b-card-text class="m-auto w-75">
          Kart bilgilerinizi kontrol edip yeniden deneyin. Sorun devam ederse bankanızla
          veya Diko destek ekibiyle iletişime geçin.
        </b-card-text>
        <div class="mt-2 d-flex flex-wrap justify-content-center">
          <b-button
            variant="primary"
            class="btn-sm-block mb-1 mb-md-0 mr-md-1"
            :to="{ name: 'financial-settings' }"
          >
            Tekrar Dene
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-sm-block"
            :to="{ name: 'home' }"
          >
            Ana Sayfaya Dön
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard, BAvatar, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import {
  fetchSubscriptionStanding,
  invalidateSubscriptionStanding,
} from '@/libs/subscriptionStanding'
import { GUIDE_ENABLED } from '@/libs/featureFlags'

export default {
  components: {
    BCard,
    BAvatar,
    BCardText,
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      refreshState: 'idle',
      standing: null,
      guideEnabled: GUIDE_ENABLED,
      // eslint-disable-next-line global-require
      appLogoImage: require('@/assets/images/logo/dikologo.svg'),
    }
  },
  computed: {
    status() {
      return (this.$route && this.$route.query && this.$route.query.status) || null
    },
    isSuccess() {
      return this.status === 'success'
    },
    // The callback redirects here when the provider charged the card but the
    // local finalization failed; the scheduled sweep retries it. Treating an
    // unknown status as a declined card is what the old single v-else did.
    isProcessing() {
      return this.status === 'processing'
    },
    isPaid() {
      return this.isSuccess || this.isProcessing
    },
    isReviewCompleted() {
      return this.status === 'review_completed'
    },
    shouldRefreshStatus() {
      return this.isPaid || this.isReviewCompleted
    },
    // L8: only the server may say a subscription exists. Until it does, the
    // page states what is actually known -- the payment was taken.
    subscriptionConfirmed() {
      return Boolean(
        this.standing
        && this.standing.contractComplete
        && this.standing.hasSubscription === true,
      )
    },
    celebrate() {
      return this.refreshState === 'loaded' && this.subscriptionConfirmed
    },
    reviewDeadlineAt() {
      const review = this.standing && this.standing.approvalReview
      return review && review.state === 'active' ? review.deadlineAt : null
    },
  },
  created() {
    if (this.shouldRefreshStatus) this.refreshSubscriptionStatus()
  },
  methods: {
    async refreshSubscriptionStatus() {
      this.refreshState = 'loading'
      invalidateSubscriptionStanding()
      try {
        this.standing = await fetchSubscriptionStanding({ forceRefresh: true })
        this.refreshState = this.standing && this.standing.contractComplete
          ? 'loaded'
          : 'error'
      } catch (error) {
        this.refreshState = 'error'
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('tr-TR', {
        timeZone: 'Europe/Istanbul',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    },
  },
}
</script>
<style scoped>
.purchase-callback {
  position: relative;
}
.brand-logo {
  display: flex;
  align-items: center;
  position: absolute;
  top: 2rem;
  left: 2rem;
  margin: 0;
  z-index: 1;
}
/* The old rule hardcoded the placeholder's 1.46:1 box. The real lockup is
   158.45 x 72.7 (~2.18:1), so height alone is fixed and the width follows. */
.brand-logo__image {
  height: 40px;
  width: auto;
}
.success,
.review-completed,
.deny {
  height: 80vh;
}
</style>
